import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { body3SemiBold } from "shared/styles/typography";

import { ContentFrameProps } from "./types";

const ContentFrame = ({ title, children, customStyles }: ContentFrameProps) => {
    const { gray300 } = colors;

    return (
        <div css={customStyles}>
            <h4 css={body3SemiBold}>{title}</h4>

            <div
                css={css({
                    marginTop: "8px",
                    border: `1px solid ${gray300}`,
                    borderRadius: "8px",
                    padding: "0 16px",

                    "& > div:not(:last-of-type)": {
                        borderBottom: `1px solid ${gray300}`
                    }
                })}
            >
                {children}
            </div>
        </div>
    );
};

export default ContentFrame;
